// 리뷰 수집 페이지의 국가 → 수집 사이트 매핑. 사이트 key는 서버(brightdata/studio.js SITES)와 같다.
export const COUNTRIES = [
  { code: 'us', label: 'U.S.', sites: ['amazon', 'sephora', 'ulta'] },
  { code: 'kr', label: 'Korea', sites: ['oliveyoung'] },
  { code: 'gb', label: 'U.K.', sites: [] },
  { code: 'de', label: 'Germany', sites: [] },
  { code: 'fr', label: 'France', sites: [] },
  { code: 'sg', label: 'Singapore', sites: [] },
  { code: 'vn', label: 'Vietnam', sites: [] },
  { code: 'th', label: 'Thailand', sites: [] },
];

export const SITE_LABELS = { amazon: 'Amazon', sephora: 'Sephora', ulta: 'Ulta', oliveyoung: 'Olive Young' };

export const DEFAULT_COUNTRY = 'us';
export const DEFAULT_SITE = 'amazon';

const findCountry = (code) => COUNTRIES.find(c => c.code === code);

// configSites: 서버 /config의 sites([{ key, enabled }]). 없는 사이트는 비활성
export function countrySites(code, configSites) {
  return (findCountry(code)?.sites ?? []).map(key => ({
    key,
    label: SITE_LABELS[key],
    enabled: !!configSites?.find(s => s.key === key)?.enabled,
  }));
}

export function isCountrySelectable(code) {
  return (findCountry(code)?.sites.length ?? 0) > 0;
}

export function firstEnabledSite(code, configSites) {
  return countrySites(code, configSites).find(s => s.enabled)?.key ?? '';
}
